import React from "react";
import { tipster } from "../mock/mock";
import { MapPin, Award, Briefcase, User } from "lucide-react";

const AboutTipster = () => {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-gradient-to-br from-[#0a1a4a] to-[#1c3aa8] relative shadow-xl">
              {tipster.photo ? (
                <img
                  src={tipster.photo}
                  alt={`${tipster.name} — Explorer Picks lead tipster`}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                  width="560"
                  height="700"
                />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center">
                  <User size={140} className="text-white/20" strokeWidth={1} />
                </div>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/70 to-transparent">
                <div className="text-white font-bold text-xl">{tipster.name}</div>
                <div className="text-white/80 text-sm">Founder & Lead Tipster</div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#ff5a5a] text-white rounded-2xl p-5 shadow-xl coral-glow">
              <div className="text-3xl font-extrabold leading-none">{tipster.experience}</div>
              <div className="text-xs uppercase tracking-wider mt-1 font-semibold">
                Years<br />Experience
              </div>
            </div>
          </div>

          <div className="mt-10 space-y-3">
            <InfoRow icon={MapPin} label="Country" value={tipster.country} />
            <InfoRow icon={User} label="Age" value={`${tipster.age} years`} />
            <InfoRow icon={Award} label="Experience" value={`${tipster.experience} years`} />
            <InfoRow icon={Briefcase} label="Field" value={tipster.fields} />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-[#ff5a5a] font-semibold tracking-widest text-xs uppercase">
            Meet the tipster
          </div>
          <h2 className="text-[#0a1a4a] text-3xl sm:text-4xl font-bold mt-3">
            Hi, I&rsquo;m {tipster.name.split(" ")[0]}.
          </h2>
          <div className="mt-6 text-[#0a1a4a]/75 leading-relaxed space-y-4">
            {tipster.bio.split("\n\n").map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="mt-8 pt-6 border-t border-slate-200">
            <div className="text-[#0a1a4a]/60 text-sm">To your success,</div>
            <div
              className="mt-1 text-2xl text-[#0a1a4a]"
              style={{ fontFamily: "'Sora', sans-serif", fontStyle: "italic" }}
            >
              {tipster.name}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const InfoRow = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-3">
    <div className="w-10 h-10 rounded-lg bg-[#ff5a5a]/10 flex items-center justify-center flex-shrink-0">
      <Icon size={18} className="text-[#ff5a5a]" />
    </div>
    <div className="flex-1">
      <div className="text-xs uppercase tracking-wider text-[#0a1a4a]/60 font-semibold">{label}</div>
      <div className="text-sm font-semibold text-[#0a1a4a]">{value}</div>
    </div>
  </div>
);

export default AboutTipster;
